import apiCommons from "../config/api_commons";

// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiCommons = axios.create({
//   baseURL: "http://localhost:8083",
// });

export function exportExcel(payload) {
  const { groupId, farmId, reportName, fileName, body } = payload;

  return apiCommons.post(
    `/bovexo/${groupId}/farms/${farmId}/reports/dynamic/exports?reportName=${reportName}&fileName=${fileName}`,
    body,
    getHeaders(false, null, true)
  );
}
